import { memo } from "react";
import { useSettingsContext } from "@/contexts/SettingsContext";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

import FooterLogo from './FooterLogo';
import styles from "./Footer.module.css";

type DoulaMenuItem = {
	title: string;
	href: string;
};

interface DoulaFooterProps {
	doulaMenuItems: DoulaMenuItem[];
}

const CURRENT_YEAR = new Date().getFullYear();

export default memo(function DoulaFooter({ doulaMenuItems }: DoulaFooterProps) {
	const { settings } = useSettingsContext();
	const websiteDescription = settings?.websiteDescription;
	const { signOut } = useAuth();
	const navigate = useNavigate();

	const handleSignOut = async () => {
		await signOut();
		navigate("/");
	};

	return (
		<footer className={`${styles.footer} bg-newTheme-spruce py-12`}>
			<div className={`${styles.footerContainer} px-4 sm:px-6 xl:px-0`}>
				<div className="grid grid-cols-1 lg:grid-cols-3 gap-8 items-start">
					<div className="flex flex-col items-center lg:items-start space-y-4">
						<div className="flex items-center space-x-2">
							<div className={styles.footerLogo}>
								<FooterLogo />
							</div>
						</div>
						{websiteDescription && (
							<p className="font-karla text-center lg:text-left">
								{websiteDescription}
							</p>
						)}
					</div>

					<div className="grid grid-cols-2 gap-4 text-center lg:text-left">
						{doulaMenuItems.length > 0 && (
							<div className="space-y-3">
								<h3 className="font-semibold text-white font-karla uppercase">
									Doula Menu
								</h3>
								<ul className="space-y-2">
									{doulaMenuItems.map((item) => (
										<li key={item.title}>
											<Link
												to={item.href}
												className="text-white font-karla transition-colors"
											>
												{item.title}
											</Link>
										</li>
									))}
								</ul>
							</div>
						)}
					</div>

					{/* Copyright and Legal Links */}
					<div className="text-center self-center lg:text-right">
						<p className="font-karla">&copy; {CURRENT_YEAR} Gaia</p>
						<p className="font-karla text-sm mt-1">
							All rights reserved.
						</p>
						<ul className="flex flex-col lg:flex-row lg:justify-end items-center gap-4 mt-4">
							<li>
								<button
									type="button"
									onClick={handleSignOut}
									className="font-karla text-sm transition-colors underline"
								>
									Sign Out
								</button>
							</li>
						</ul>
					</div>
				</div>
			</div>
		</footer>
	)
});